// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1VjrJ","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3a8Vs"};